export const currentUser = (state) => state.currentUser.name;
export const isLoading = (state) => state.currentUser.isLoading;
export const error = (state) => state.currentUser.error;
export const currentUserId = (state) => state.currentUser.name.userDto.id;
export const isRegisteredSuccessfully = (state) =>
  state.currentUser.successfullyRegistered;
export const isAdmin = (state) =>
  ['SUPER_ADMIN', 'ADMIN'].includes(state.currentUser.name?.role);
